<div class="tradable-transaction-list-item-container">
  <div class="list-item" [ngClass]="{ 'has-share-button': showShareButton && !isInnerIndexTransaction }">
    @if (transaction) {
      <div
        class="bp-modal mod-tx-list"
			[ngClass]="{
				'mod-full': canOpen,
				'mod-lg': !canOpen,
				'card-interactive': canOpen && !isActivityOrHistory()
			}"
        [class.focusable]="focusable"
        (keydown.enter)="focusable && toggle()"
        [tabIndex]="focusable ? 0 : -1">
        @if (isIndexTx()) {
          <div class="modal-grey-background">
            <index-transaction-list-header
              (click)="toggle()"
              [activity]="activity"
              [canOpen]="canOpen"
              (closeEmitter)="closeEmitter.emit()"
              [transaction]="transaction"
              [isWidget]="isWidget">
            </index-transaction-list-header>
            @if (!canOpen) {
              <index-transaction-list-detail
                [showShareButton]="showShareButton"
                [transaction]="transaction"
                >
              </index-transaction-list-detail>
            }
          </div>
          @if (showShareButton) {
            <div class="footer-wrapper">
              @if (transaction.canBeShared() && !isInnerIndexTransaction && !canOpen) {
                <share-button
                  class="share-button-footer"
                  [transaction]="transaction"
                [isFooterBtn]="true"></share-button>
              }
            </div>
          }
        } @else {
          <asset-transaction-list-header
            (click)="toggle()"
            [activity]="activity"
            [canOpen]="canOpen"
            (closeEmitter)="closeEmitter.emit()"
            [transaction]="transaction"
            [isWidget]="isWidget">
          </asset-transaction-list-header>
          @if (!canOpen) {
            <asset-transaction-list-detail
              (closeEmitter)="closeEmitter.emit($event)"
              [transaction]="transaction"
            ></asset-transaction-list-detail>
          }
          @if (activity !== 'activity') {
            <actions-bar [transaction]="transaction" [canOpen]="canOpen">
            </actions-bar>
          }
          @if (!canOpen) {
            <asset-transaction-list-footer
              [showShareButton]="showShareButton"
              [transaction]="transaction"
              [PID]="pid"
              [balance]="balance | async">
            </asset-transaction-list-footer>
          }
        }
      </div>
    }
  </div>
  @if (showShareButton && !isInnerIndexTransaction) {
    @if (transaction.canBeShared() && canOpen) {
      <share-button
        class="share-button-list-item"
      [transaction]="transaction"></share-button>
    }
  }
</div>
